export default __webpack_public_path__ + "static/media/indoorCenter.ba3edf42.png";